import { gql } from '@apollo/client';

export const RESET_ACQUISITION_MUTATION = gql`
    mutation restartOneAcquisition($where: AcquisitionWhereUniqueInput!) {
        restartOneAcquisition(where: $where) {
            acquisitionId
        }
    }
`;
